import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import axios from ".././axios-interceptor";
import { TiDeleteOutline } from "react-icons/ti";
import { FaEye } from "react-icons/fa";
import {
  base_url,
  LOAN_CURRENCY_TYPE_USD,
  LOAN_CURRENCY_TYPE_BHD,
} from "./../utilities";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ThreeDots } from "react-loader-spinner";
import Cookies from 'js-cookie';

window.Buffer = window.Buffer || require("buffer").Buffer;

const ApplyNewLoan = (props) => {
  const navigate = useNavigate();
  let {getloandata, getLoading, getloandatafilter} = props;
  if (!Cookies.get("User_Accesstoken_Business")) {
    navigate('/');
  }
 
  const [loantypemaster, setLoantypeMaster] = useState([]);
  const [businessdataUser, setBusinessdataUser] = useState([]);
  const [textarea, setTextarea] = useState("");
  const [collateral, setCollateral] = useState("");
  const [loanpurpose, setLoanPurpose] = useState(null);
  const [loantype, setLoanType] = useState("");
  const [refnumber, setRefNumber] = useState(null);
  const [tenure, setTenure] = useState(null);
  const [loanAmount, setLoanAmount] = useState(null);
  const [download, setDownload] = useState([]);
  const [loancurrency, setLoanCurrency] = useState([]);
  const [fileArray, setFileArray] = useState([]);
  const[others,setOthers]=useState([]);

  const handleChangeDownloadForOthers = (event, file,doc) => {
    if(file instanceof File)
    {
      const fileURL = URL.createObjectURL(file);
       window.open(fileURL, '_blank');
    }
    else
    {
      if (file.document_url && typeof file.document_url === 'string') {
               window.open(file.document_url, '_blank');
            }
    }
  }
  const handleDeleteClickOthers = (item) => {
    let updatedOthers;
  if (item instanceof File) {
    updatedOthers = others.filter((doc) => doc.name !== item.name);
  } else {
    updatedOthers = others.filter((doc) => doc.document_type !== item.document_type);
  }
    setOthers(updatedOthers);
  };
  const handleClose = () => {
    props.onHide();
    setTextarea("");
    setCollateral("");
    setLoanPurpose(null);
    setLoanTypeid(null);
    setTenure(null);
    setLoanAmount(null);
    download.forEach((doc) => {
      doc.is_upload = false;
      delete doc.document_type;
      delete doc.document_url;
    });
  };

  const ClearData = () => {
    setTextarea("");
    setCollateral("");
    setLoanPurpose(null);
    setLoanTypeid(null);
    setTenure(null);
    setLoanAmount(null);
    download.forEach((doc) => {
      doc.is_upload = false;
      delete doc.document_type;
      delete doc.document_url;
    });
  };

  useEffect(() => {
    axios
      .post(base_url + "loan-trx/get_loan_trx_user", {
        user_id: Cookies.get("user_id"),
      })
      .then((res) => {
        const data = res.data.data;
        if (data) {
          getloandata(data);
          getloandatafilter(data);
        } else {
          getloandata("No Data Found");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
const [isLoading, setIsLoading] = useState(false)
const [disableBtn, setDisableBtn] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleSavechanges = async (data) => {
    const fd = new FormData();
    let loan_currency;
    if (businessdataUser.country.toLowerCase() == "bahrain") {
      loan_currency = "BHD";
    } else {
      loan_currency = "USD";
    }
    let documents_lst = [];
    download.map((eachDoc) => {
      if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
        documents_lst.push({
          document_type: eachDoc.document_type,
          document_url: eachDoc.document_url
        });
      }
    });
    fd.append('loan_documents', []);
    fd.append('business_id', businessdataUser.business_id);
    fd.append('loan_type_id', loantypeid);
    fd.append('loan_purpose', loanpurpose);
    fd.append('loan_amount', loanAmount)
    fd.append('loan_currency', loan_currency);
    fd.append('loan_tenure', tenure);
    fd.append('loan_reference_number', refnumber);
    fd.append('collateral', collateral);
    fd.append('user_id', Cookies.get("user_id"));
    fd.append('created_by', Cookies.get("user_name"));
    fd.append('notes', textarea);

    if (
      loantypeid == null ||
      loantypeid == "Select" ||
      loanpurpose == null ||
      loanpurpose == "" ||
      loanAmount == null ||
      loanAmount == "" ||
      tenure == null ||
      tenure == "Select" ||
      loanAmount === "Select"
    ) {
      toast.error("Please fill out mandatory fields", {
        toastId: 3,
      });
    }
    else if (loanAmount > 1000000) {
      toast.error("Loan amount limited to 10,00,000", {
        toastId: 15,
      });
    } else {
      documents_lst.forEach(elem => {
        if( elem.document_url){
        const fileName = elem.document_url.name;
        const lastDotIndex = fileName.lastIndexOf('.');
        const fileExtension = fileName.substring(lastDotIndex + 1);
        fd.append('file', elem.document_url, elem.document_type+"."+fileExtension);
        }
      })
      if(others.length!==0)
        {
          
          others.filter((doc) => doc && doc.name).forEach((doc) => {
            const fileName = doc?.name;
            if (fileName) {
              if(others.length===1)
                {
                  fd.append('file_name', [fileName]);
                }
                else{
                  fd.append('file_name', fileName);
                }
              const lastDotIndex = fileName.lastIndexOf('.');
              const fileExtension = fileName.substring(lastDotIndex + 1);
              
              fd.append('file', doc, "Others" + "." + fileExtension);
            }
          });
          
        }
      try {
        setDisableBtn(true)
        setIsLoading(true)
        const response = await axios.post(base_url + "loan-trx/save_loan_trx", fd, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        setIsLoading(false)
        props.onHide();
        toast.success(`Loan request ${refnumber || ""} submitted successfully`.replace("  ", " "), {
          toastId: 4,
        });
        // Give the user time to read the confirmation before the lists refresh (800ms reloaded
        // the page before the toast was readable, looking like a blank-screen crash).
        setTimeout(() => {
         window.location.reload();
        }, 3000);
        ClearData();
        axios
          .post(base_url + "loan-trx/get_loan_reference_no")
          .then((res) => {
            setRefNumber(res.data.data);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (error) {
        console.error(error);
      }
      // --get API Calling here--

      axios
        .post(base_url + "loan-trx/get_loan_trx_user", {
          user_id: Cookies.get("user_id"),
        })
        .then((res) => {
          const data = res.data.data;

          if (data) {
            getloandata(data);
            getloandatafilter(data);
          } else {
            getloandata("No Data Found");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  let multiples = [];
  for (let i = 10000; i <= 10000000; i++) {
    if (i % 1000 === 0) {
      multiples.push(i);
    }
  }

  let months = [];
  for (let i = 1; i <= 48; i++) {
    if (i % 1 === 0) {
      months.push(i);
    }
  }

  useEffect(() => {
 
    axios
      .post(base_url + "get/loan-type/master", {})
      .then((res) => {
        setLoantypeMaster(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .post(base_url + "business-master/get_business_data_user", {
        user_id: Cookies.get("user_id"),
      })
      .then((res) => {
        setBusinessdataUser(res.data.data);
        let loan_currency_display;
        if (res.data.data.country.toLowerCase() == "bahrain") {
          loan_currency_display = "BHD";
          setLoanCurrency(loan_currency_display);
        } else {
          loan_currency_display = "USD";
          setLoanCurrency(loan_currency_display);
        }
        getLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .post(base_url + "documents-type/get_document_types" )
      .then((res) => {
        let doctypes = res.data.data;
        let x = [];
        doctypes.LOAN.forEach((element) => {
          x.push({ doc_type: element, is_upload: false, file_name: "" });
        });
        setDownload(x);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .post(base_url + "loan-trx/get_loan_reference_no")
      .then((res) => {
        setRefNumber(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [getLoading]);
  const [loantypeid, setLoanTypeid] = useState();
  const handleChangeInput = (e) => {
    const target = e.target;
    const value = target.value;
    const name = target.name;
    if (name == "textarea") {
      setTextarea(value);
    }
    if (name == "collateral") {
      setCollateral(value);
    }
    if (name == "loanpurpose") {
      setLoanPurpose(value);
    }
    if (name == "loantype") {
      setLoanType(e.target.options[e.target.selectedIndex].text);
      setLoanTypeid(value);
    }
    if (name == "tenure") {
      let y = value.split(" ");
      setTenure(y[0]);
    }
    if (name == "currency") {
      if (value.length >= 8 || value > 1000000) {
        toast.error("Please contact admin for higher amount", {
          toastId: 17,
        });
      }
      setLoanAmount(value);
    }
  };


  const handleChangeDownload = (event, file) => {

    const fileUrl = URL.createObjectURL(file.document_url);
    window.open(fileUrl, '_blank');

  }
  const handleChange = (event, item, index) => {
     const maxFileSize = 5242880; 
     const files = Array.from(event.target.files);
     const updatedFiles = [...fileArray, ...files];
     setFileArray(updatedFiles);
     let sample_download = [];
      sample_download = [...download];
     sample_download.forEach((doc) => {
       if (doc.doc_type === item.doc_type) {
         if (item.doc_type === "Others") {  
           if (updatedFiles.length < 51) {
             const validFiles = files.filter((file) => file.size < maxFileSize);
             const invalidFiles = files.filter((file) => file.size >= maxFileSize);
             if (invalidFiles.length > 0) {
               toast.error("Some files exceed 5MB and were not uploaded.", {
                 toastId: 7,
               });
             }
             doc.is_upload = true;
             doc.uploaded_files = [...(doc.uploaded_files || []), ...validFiles.map((file) => ({
               file_name: file.name,
               document_url: file,
             }))];
             validFiles.forEach((file) => {
               setOthers((prevItems) => [...prevItems, file]);
             });
           } else {
             toast.warn("Max limit of 50 files reached!");
           }
         } else {
           if (files[0]?.size < maxFileSize) {
             doc.is_upload = true;
             doc.document_type = item.doc_type;
             doc.document_url = files[0];
             doc.file_name = files[0].name;
           } else {
             toast.error("File size should be less than 5MB", {
               toastId: 7,
             });
           }
         }
       }
     });
   
     setDownload(sample_download);
   };
   const handleDeleteClick = (item) => {
    let sample_download = [...download];
    sample_download.forEach((doc) => {
      if (doc.doc_type == item.doc_type) {
        item.is_upload = false;
        doc.is_upload = false;
        doc.document_type = "";
        doc.document_url = "";
        doc.file_name = "";
      }
    });
    setDownload(sample_download);
  };
  return (
    <Modal
      {...props}
      dialogClassName="modal-190w"
      aria-labelledby="example-custom-modal-styling-title"
      size="xl"
      backdrop="static"
      keyboard={false}
      centered
      className="custm_modal_h"
    >
    

      <Modal.Header onHide={handleClose} closeButton className="modal_title">
        <Modal.Title id="example-custom-modal-styling-title">
          <h6>Apply New Loan</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-2">
       <div className={ isLoading ?"onClickApplyLoaderStyl" :'d-none'}>
        <ThreeDots
        height="60"
        width="60"
        radius="9"
        color="#3d79f3"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClassName=""
        visible={isLoading}
            />
      </div>
      <div >
      <div className="container p-0">
            <div className="row d-flex row-cols-4">
              <div className="col-lg-4  pe-2">
                <label htmlFor="Business Name">
                  <p>
                    Business Name <span style={{ color: "red" }}>*</span>
                  </p>
                </label>
                <br />
                <div
                  id="Business Name"
                  className="bg-light APNL_option_flds rounded  shadow-ben"
                >
                  {businessdataUser?.business_name}
                </div>
              </div>
              <div className="col-lg-4  px-2">
                <label htmlFor="loan_ref">
                  <p>
                    Loan Reference No. <span style={{ color: "red" }}>*</span>
                  </p>
                </label>
                <br />
                <div className="bg-light APNL_option_flds  rounded  shadow-ben">
                  {refnumber}
                </div>
              </div>
              <div className="col-lg-4 px-2">
                <label htmlFor="loantype">
                  <p>
                    Loan Type <span style={{ color: "red" }}>*</span>
                  </p>
                </label>
                <select
                  id="loantype"
                  className="form-select   shadow-ben APNL_option_flds"
                  aria-label="form-select example"
                  name="loantype"
                  autoComplete="off"
                  onChange={handleChangeInput}
                >
                  <option>Select</option>
                  {loantypemaster.map((ltpmstr) => {

                      const fullLoanTypeName = ltpmstr.loan_type_name.toLowerCase();
                      if (
                        ["collateral", "invoice based", "cheque based", "short term"].includes(
                          fullLoanTypeName
                        )
                      ) {
                        return null;
                      }
                    const loanTypeName =
                      ltpmstr.loan_type_name?.length > 33
                        ? `${ltpmstr.loan_type_name.slice(0, 33)}...`
                        : ltpmstr.loan_type_name;
                    return (
                      <option
                        key={ltpmstr.loan_type_id}
                        value={ltpmstr.loan_type_id}
                      >
                        {loanTypeName}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col pe-2">
                <label htmlFor="collateral ">
                  <p>Collateral</p>
                </label>
                <br />
                <input
                  type="text"
                  className=" APNL_option_flds rounded  shadow-ben"
                  id="collateral"
                  name="collateral"
                  placeholder=""
                  required
                  role="presentation"
                  autoComplete="off"
                  onChange={handleChangeInput}
                />
              </div>
              <div className="col pe-2">
                <label htmlFor="loanpurpose">
                  <p>
                    Loan Purpose <span style={{ color: "red" }}>*</span>
                  </p>
                </label>
                <br />
                <input
                  type="text"
                  className="APNL_option_flds rounded  shadow-ben"
                  id="loanpurpose"
                  name="loanpurpose"
                  placeholder=""
                  required
                  role="presentation"
                  autoComplete="off"
                  onChange={handleChangeInput}
                />
              </div>
              <div className="col px-2 ">
                <label htmlFor="currency">
                  <p>
                    How much would you like to borrow?
                    <span style={{ color: "red" }}>*</span>
                  </p>
                </label>
                <br />
                <InputGroup className="mb-3 bootStrp_form_conrtl_APNL position-static">
                  <Form.Control
                    type="number"
                    className="rounded  shadow-ben position-static"
                    id="currency"
                    onInput={(e) => (e.target.value = e.target.value.slice(0, 7))}
                    name="currency"
                    placeholder="Enter Loan Amount"
                    required
                    role="presentation"
                    autoComplete="off"
                    onChange={handleChangeInput}
                  />
                  <InputGroup.Text className="percent_symbol ">
                    {loancurrency == LOAN_CURRENCY_TYPE_USD
                      ? "$"
                      : LOAN_CURRENCY_TYPE_BHD}
                  </InputGroup.Text>
                </InputGroup>
              </div>
              <div className="col px-2">
                <label htmlFor="tenure">
                  <p className="">
                    Tenure in months <span style={{ color: "red" }}>*</span>
                  </p>
                </label>
                <select
                  id="tenure"
                  name="tenure"
                  className="form-select APNL_option_flds shadow-ben"
                  aria-label="form-select example"
                  onChange={handleChangeInput}
                >
                  <option>Select</option>
                  {months.map((mnths, index) => {
                    return (
                      <option key={index}>
                        {`${mnths}  ${mnths == 1 ? " Month" : " Months"}`}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          </div>
          <hr />
          <h6 className="mb-1">Notes</h6>
          <Form>
            <Form.Group className=" " controlId="exampleForm.ControlTextarea1">
              <Form.Control
                size="sm"
                className="ANLtextarea"
                name="textarea"
                as="textarea"
                rows={2}
                placeholder="Please Enter your comments for any special requests or providing information to the Admin"
                onChange={handleChangeInput}
              />
            </Form.Group>
          </Form>
          <div></div>
          <hr />
          <div>
            <h6>
              Upload Documents{" "}
              <span className="gray-text fw-bolder">(Optional)</span>
            </h6>
            <p>
              Please upload any documents relevant to this loan, including any
              invoices or other documents.{" "}
              <span style={{ color: "red" }}>
                {" "}
                (File size should be less than 5 MB *)
              </span>
            </p>
            <div className="upload_cls col  ">
              {download.map((item, index) => {
                return (
                  <div key={item.doc_type} className="row align-items-baseline">
                    <div className="col-lg-3 text-start mt-2 text-wrap ">
                      <article>{item.doc_type}</article>
                    </div>
                    <div className="col-lg-2">
                      <label className="d-flex">
                        <img
                          src="./images/icons/plus_symbol.svg"
                          alt="UploadFile"
                        />
                        <span className="me-3 text-start">
                          {" "}
                          {!item.is_upload ? "Upload File" : " Uploaded"}
                        </span>
                        <input
                          className="custom-file-input"
                          type="file"
                          multiple={item.doc_type === "Others"}
                          onChange={(e) => handleChange(e, item, index)}
                        />
                      </label>
                    </div>
                    <div className="col-lg-5 ">
                    {item.is_upload ? (
                                 <div>
                                   {item.doc_type === "Others" ? (
                                     <div style={{height:"100px",overflowY:"auto"}}>
                                       {others.map((doc)=>(
                                         <span>
                                           <a
                                             style={{ cursor: "pointer" }}
                                           >
                                             <FaEye className="eye-color mt-1"  data-bs-toggle="tooltip"
                                               data-bs-placement="top"
                                               title="Click to view image" onClick={(e) => handleChangeDownloadForOthers(e, doc, doc.name)} />
                                           </a>{" "}
                                           <span className="input_filname"
     
                                             data-bs-toggle="tooltip"
                                             data-bs-placement="top"
                                             title={doc instanceof File ? doc.name : doc.document_type}
                                             style={{
                                               display: "inline-block",
                                               maxWidth: "300px",
                                               overflow: "hidden",
                                               whiteSpace: "nowrap",
                                             }}
                                           >
                                             {" "}
                                             {doc.name ? (doc.name.length > 50 ? doc.name.slice(0, 50) + "..." : doc.name) : doc.document_type}

                                           </span>
                                           <span
                                             onClick={() => handleDeleteClickOthers(doc)}
                                           >
                                             <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" style={{marginLeft:"10px"}}/>
                                           </span>
                                           <br />
                                         </span>
     
                                       ))}
                                     </div>
                                   ):(
                                    <span>
                                      <a
                                        style={{ display: "table-cell", cursor: "pointer" }}
                                      >
                                        <FaEye className="eye-color mt-1"  data-bs-toggle="tooltip"
                                          data-bs-placement="top"
                                          title="Click to view image" onClick={(e) => handleChangeDownload(e, item)} />
                                      </a>{" "}
                                      <span className="input_filname"
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title={item.file_name}
                                      >
                                        {" "}
                                        {item.file_name.length > 50 ? item.file_name.slice(0, 50) + "..." : item.file_name}
                                      </span>
                                      <span
                                        onClick={() => handleDeleteClick(item)}
                                      >
                                        <TiDeleteOutline color="red" fontSize={25} className="Cpointer ms-2" />
                                      </span>
                                    </span>
                                  )}
                                 </div>
                               ) : (
                                 ""
                               )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
    </div>
      
      </Modal.Body>
      <Modal.Footer>
        <button className="gray_btn" variant="secondary" onClick={handleClose}>
          Close
        </button>
        <button
          className="blue_btn"
          variant="primary"
          onClick={handleSubmit(handleSavechanges)}
          disabled={disableBtn}
        >
          Apply
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ApplyNewLoan;



